import React, { Suspense } from "react";
import { Toaster } from "react-hot-toast";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import MoonLoader from "./components/MoonLoader";
import PageLayout from "./components/PageLayout";
import ScrollToTop from "./components/ScrollToTop";

const LazyUserManagement = React.lazy(() =>
  import("./pages/Admin/UserManagement/UserManagement")
);

const LazyTransactionManagement = React.lazy(() =>
  import("./pages/Admin/TransactionManagement/TransactionManagement")
);
const LazyPuzzleCategoryManagement = React.lazy(() =>
  import("./pages/Admin/PuzzleCategoryManagement/PuzzleCategoryManagement")
);

const LazyStreakTransactions = React.lazy(() =>
  import("./pages/Admin/StreakTransactions/StreakTransactions")
);
const LazyPuzzleTransactions = React.lazy(() =>
  import("./pages/Admin/PuzzleTransactions/PuzzleTransactions")
);
const LazyPuzzleSettings = React.lazy(() =>
  import("./pages/Admin/PuzzleSettings/index")
);
const LazyMediaManagement = React.lazy(() =>
  import("./pages/Admin/MediaManagement/MediaManagement")
);

const LazyPuzzleManagement = React.lazy(() =>
  import("./pages/Admin/PuzzleManagement/PuzzleManagement")
);
const LazyBannerManagement = React.lazy(() =>
  import("./pages/Admin/BannerManagement")
);
const LazyServiceManagement = React.lazy(() =>
  import("./pages/Admin/ServiceManagement")
);
const LazyPlaceManagement = React.lazy(() =>
  import("./pages/Admin/PlaceManagement")
);
const LazyLocationManagement = React.lazy(() =>
  import("./pages/Admin/LocationManagement")
);
const LazyServiceProviderManagement = React.lazy(() =>
  import("./pages/Admin/ServiceProviderManagement")
);
const LazyCountryManagement = React.lazy(() =>
  import("./pages/Admin/CountryManagement")
);
const LazyStateManagement = React.lazy(() =>
  import("./pages/Admin/StateManagement")
);
const LazyDistrictManagement = React.lazy(() =>
  import("./pages/Admin/DistrictManagement")
);
const LazyCityManagement = React.lazy(() =>
  import("./pages/Admin/CityManagement")
);
const LazyQuestionManagement = React.lazy(() =>
  import("./pages/Admin/QuestionManagement/QuestionManagement")
);

const LazyImportQuestions = React.lazy(() =>
  import("./pages/Admin/ImportQuestions")
);
const LazyImportedQuestions = React.lazy(() =>
  import("./pages/Admin/ImportedQuestions")
);
const LazyPracticeQuestions = React.lazy(() =>
  import("./pages/Admin/PracticeQuestions")
);
const LazyQuiz = React.lazy(() => import("./pages/Quiz"));
const LazyAdmin = React.lazy(() => import("./pages/Admin"));
const LazyResults = React.lazy(() => import("./pages/Admin/Results/Results"));
const LazyMathMasterReport = React.lazy(() =>
  import("./pages/Admin/MathMasterReport/MathMasterReport")
);
const LazyMathMasterConfig = React.lazy(() =>
  import("./pages/Admin/MathMasterConfig")
);
const LazyCoinRateConfig = React.lazy(() =>
  import("./pages/Admin/CoinRateConfig")
);
const LazyQuizCategoryManagement = React.lazy(() =>
  import("./pages/Admin/QuizCategoryManagement/QuizCategoryManagement")
);
const LazyServiceCategoryManagement = React.lazy(() =>
  import("./pages/Admin/ServiceCategoryManagement/ServiceCategoryManagement")
);
const LazyQuizStats = React.lazy(() =>
  import("./pages/Admin/QuizStats/QuizStats")
);

const LazyQuizMasters = React.lazy(() => import("./pages/Admin/QuizMasters"));
const LazyProductManagement = React.lazy(() =>
  import("./pages/Admin/Shop/ProductManagement/ProductManagement")
);
const LazyStreakSettings = React.lazy(() =>
  import("./pages/Admin/StreakSettings")
);
const LazyProductTransactionManagement = React.lazy(() =>
  import(
    "./pages/Admin/Shop/ProductTransactionManagement/ProductTransactionManagement"
  )
);
const LazyOrderManagement = React.lazy(() =>
  import("./pages/Admin/Shop/OrderManagement/OrderManagement")
);

const App = () => {
  return (
    <ScrollToTop>
      <Suspense fallback={<MoonLoader />}>
        <Toaster />
        <PageLayout>
          <Routes>
            <Route path="/" element={<LazyAdmin />} />
            <Route
              path="/admin/user-management"
              element={<LazyUserManagement />}
            />
            <Route
              path="/admin/media-management"
              element={<LazyMediaManagement />}
            />
            <Route
              path="/admin/puzzle-management"
              element={<LazyPuzzleManagement />}
            />
            <Route
              path="/admin/banner-management"
              element={<LazyBannerManagement />}
            />
            <Route
              path="/admin/service-management"
              element={<LazyServiceManagement />}
            />
            <Route
              path="/admin/serviceprovider-management"
              element={<LazyServiceProviderManagement />}
            />
            <Route
              path="/admin/mathmaster-report"
              element={<LazyMathMasterReport />}
            />
            <Route
              path="/admin/mathmaster-config"
              element={<LazyMathMasterConfig />}
            />
            <Route
              path="/admin/coinrate-config"
              element={<LazyCoinRateConfig />}
            />
            <Route
              path="/admin/question-management"
              element={<LazyQuestionManagement />}
            />
            <Route
              path="/admin/import-questions"
              element={<LazyImportQuestions />}
            />
            <Route
              path="/admin/imported-questions"
              element={<LazyImportedQuestions />}
            />
            <Route
              path="/admin/practice-questions"
              element={<LazyPracticeQuestions />}
            />
            <Route
              path="/admin/transaction-management"
              element={<LazyTransactionManagement />}
            />
            <Route
              path="/admin/streak-transactions"
              element={<LazyStreakTransactions />}
            />
            <Route
              path="/admin/quiz-category-management"
              element={<LazyQuizCategoryManagement />}
            />
            <Route
              path="/admin/product-management"
              element={<LazyProductManagement />}
            />{" "}
            <Route
              path="/admin/product-transaction-management"
              element={<LazyProductTransactionManagement />}
            />
            <Route
              path="/admin/streak-settings"
              element={<LazyStreakSettings />}
            />{" "}
            <Route
              path="/admin/puzzle-settings"
              element={<LazyPuzzleSettings />}
            />{" "}
            <Route
              path="/admin/puzzle-transactions"
              element={<LazyPuzzleTransactions />}
            />{" "}
            <Route
              path="/admin/puzzle-category-management"
              element={<LazyPuzzleCategoryManagement />}
            />{" "}
            <Route
              path="/admin/service-category-management"
              element={<LazyServiceCategoryManagement />}
            />{" "}
            <Route
              path="/admin/service-country-management"
              element={<LazyCountryManagement />}
            />{" "}
            <Route
              path="/admin/service-state-management"
              element={<LazyStateManagement />}
            />{" "}
            <Route
              path="/admin/service-district-management"
              element={<LazyDistrictManagement />}
            />{" "}
            <Route
              path="/admin/service-city-management"
              element={<LazyCityManagement />}
            />{" "}
            <Route
              path="/admin/service-place-management"
              element={<LazyPlaceManagement />}
            />{" "}
            <Route
              path="/admin/service-location-management"
              element={<LazyLocationManagement />}
            />{" "}
            <Route
              path="/admin/order-management"
              element={<LazyOrderManagement />}
            />
            <Route path="/admin/quizmasters" element={<LazyQuizMasters />} />
            <Route path="/admin/quiz-stats" element={<LazyQuizStats />} />
            <Route path="/admin/quizmasters/:id" element={<LazyQuizStats />} />
            <Route
              path="/admin/quiz/:id/submissions"
              element={<LazyResults />}
            />
            <Route path="/quiz/:id" element={<LazyQuiz />} />
          </Routes>
        </PageLayout>
      </Suspense>
    </ScrollToTop>
  );
};

export default App;
